import React from 'react';
import './logo.scss';

const Logo = () => {
  return (
    <div className="flex-row logo">
      <img width={50} height={50} src={process.env.PUBLIC_URL + '/logo.png'} />
      <h3>شير مي</h3>
    </div>
  );
};

export default Logo;
